import $ from 'jquery'
import LazyLoad from 'vanilla-lazyload';

// define global functions here
export default class app {
  init(){
    this.getSiteName()
    this.cleanAnchorHref()
    this.lazyLoad()
    this.externalUrl();
    this.reverseEmail();
    this.constantContact();
  }

  constantContact(){
    var waitForEl = function (selector, callback) {
      if (jQuery(selector).length) {
        callback();
      } else {
        setTimeout(function () {
          waitForEl(selector, callback);
        }, 100);
      }
    };

    waitForEl('.ctct-form-element', function () {
      $('.ctct-form-element').attr('placeholder', 'Email');
    });
  }


  reverseEmail(){
    function reverse(s){
      return s.split("").reverse().join("");
    }
    $('.rev-email').each(function(){
      
      let emailText = $(this).text();
      $(this).text(reverse(emailText));
      $(this).on('click', function(e){
        e.preventDefault();
        const emailTo = $(this).text();
        window.open(`mailto:${reverse(emailTo)}`, '_blank')
      })
    })
  }

  externalUrl(){
    var host = window.location.hostname;
    $('a[href^="https://"], a[href^="http://"]').not('a[href*="'+ host +'"]').attr('target','_blank');
  }

  getSiteName() {
    return $("head title").text();
  }

  cleanAnchorHref() {
    // HACK: sometimes craft inexplicably add index.php?p= to all links, even when the 'omitScriptNameInUrls' general config is set to true. see: https://craftcms.com/support/remove-index.php
    // this code removes the unwanted url modification from all links on the frontend.
    $("a").each(function() {
      var $a = $(this);
      var hrefMod = $a.attr("href");
      if (hrefMod) {
        hrefMod = hrefMod.replace("index.php?p=", "");
      }
      $a.attr("href", hrefMod);
    });
  }

  lazyLoad(){
    const myLazyLoad = new LazyLoad({
      elements_selector: ".lazyload"
    });
    const bgLazyLoad = new LazyLoad({
      elements_selector: ".bg-lazy"
    });
  }
}
